import React from 'react';
import { AuthLayout } from '../auth-layout.component';
import { ResetPassword } from './reset-password.component';

export const ResetPasswordScreen = (): React.ReactElement => {
    return <AuthLayout component={<ResetPassword />} />;
};
